import React from "react";
import { Seo } from "../seo/Seo";
import "./Instagram.css";

/**
 * Registered with Meta as the Instagram Business Login redirect URI.
 * The server-side OAuth exchange is added when the production integration is
 * configured; this page intentionally does not display authorization values.
 */
export const InstagramAuthCallback = () => (
  <main className="instagram-auth-callback">
    <Seo
      title="Instagram Authorization — Valere Kissi"
      description="Instagram authorization callback for Valere Kissi."
      path="/instagram/callback"
      noindex
    />
    <h1>Instagram authorization complete</h1>
    <p>You may close this window and return to the Meta app dashboard.</p>
  </main>
);
